module.exports = __webpack_public_path__ + "static/media/honeycomb.fb940694.svg";